<script lang="ts">
	import { Breadcrumb, BreadcrumbItem } from "flowbite-svelte";
	import type { Folder } from "#gen/folder/v1/folders_pb.js";

	interface Props {
		folderPath: Folder[];
	}

	let { folderPath = $bindable() }: Props = $props();

	function onClickBreadcrumb(idx: number) {
		folderPath = folderPath.slice(0, idx + 1);
	}
</script>

{#if folderPath.length > 1}
	<Breadcrumb class="mb-4">
		{#each folderPath as folder, i (folder.id)}
			{#if i === 0}
				<BreadcrumbItem classHome="text-gray-600 hover:underline cursor-pointer" onclick={() => onClickBreadcrumb(i)} home>
					<div slot="icon"></div>
					All files
				</BreadcrumbItem>
			{:else}
				<BreadcrumbItem classSpan="text-gray-600 hover:underline cursor-pointer" onclick={() => onClickBreadcrumb(i)}>
					<div slot="icon" class="font-normal text-gray-400">/</div>
					{folder.name}
				</BreadcrumbItem>
			{/if}
		{/each}
	</Breadcrumb>
{/if}
